import React, { forwardRef } from 'react';
import { Card } from '@mui/material';
import {
  LOGIN_CARD_BG_DARK,
  LOGIN_CARD_BG_LIGHT,
  LOGIN_CARD_BORDER,
  LOGIN_CARD_SHADOW_BASE_DARK,
  LOGIN_CARD_SHADOW_BASE_LIGHT,
  LOGIN_CARD_SHADOW_HOVER_DARK,
  LOGIN_CARD_SHADOW_HOVER_LIGHT,
} from '../../utils/colors';

/**
 * Dashboard glass surface — LOGIN_CARD_* tokens (matches login page).
 */
const GlassCard = forwardRef(function GlassCard(
  { hoverable = true, sx, ...props },
  ref,
) {
  return (
    <Card
      ref={ref}
      elevation={0}
      sx={[
        (theme) => {
          const isDark = theme.palette.mode === 'dark';
          const bg = isDark ? LOGIN_CARD_BG_DARK : LOGIN_CARD_BG_LIGHT;
          const baseShadow = isDark ? LOGIN_CARD_SHADOW_BASE_DARK : LOGIN_CARD_SHADOW_BASE_LIGHT;
          const hoverShadow = isDark ? LOGIN_CARD_SHADOW_HOVER_DARK : LOGIN_CARD_SHADOW_HOVER_LIGHT;
          return {
            position: 'relative',
            backgroundImage: 'none',
            overflow: 'hidden',
            border: `1px solid ${LOGIN_CARD_BORDER}`,
            borderRadius: 3,
            bgcolor: bg,
            boxShadow: baseShadow,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            ...(hoverable
              ? {
                  '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: hoverShadow,
                  },
                }
              : {}),
          };
        },
        sx,
      ]}
      {...props}
    />
  );
});

export default GlassCard;
